document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const href = a.getAttribute('href');
  if (!href || href === '#') return;

  e.preventDefault();

  const targetId = href.slice(1);
  const target = document.getElementById(targetId);
  if (!target) return;

  let headerOffset = 90;
  // window.innerWidth が 600px 以下のときはヘッダーの高さを 0 にする
  if (window.innerWidth <= 767) {
    headerOffset = 78;
  }
  const toc = document.querySelector('.vk_tableOfContents');
  if (toc) headerOffset += toc.offsetHeight;

  const y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

  window.scrollTo({ top: y, behavior: 'smooth' });
}, true);